import 'waypoints/lib/noframework.waypoints.min.js';

// Featured Photo Slide In

const featurePhotos = Array.from(document.querySelectorAll('.js-featuredPhoto'));

if (featurePhotos.length > 0) {
  featurePhotos.forEach(function configWaypoint(featuredPhoto) {
    // eslint-disable-next-line no-unused-vars
    const waypoint = new Waypoint({
      element: featuredPhoto,
      handler: () => {
        featuredPhoto.classList.add('-revealed');
      },
      offset: '100%',
    });
  });
}

// / Dom Nodes
const subServiceBlocks = Array.from(document.querySelectorAll('.js-subService'));

const subServiceCloseButtons = Array.from(
  document.querySelectorAll('.js-subServiceExpand')
);

subServiceBlocks.forEach(subServiceBlock => {
  subServiceBlock.addEventListener('click', () => {
    // For scoping all activity to it's parent 'serviceLists` block.
    const currentBlockId = subServiceBlock.getAttribute('data-block-id');

    // All sub-services within this block.
    const siblingSubServices = Array.from(
      document.querySelectorAll(`.js-subService[data-block-id="${currentBlockId}"]`)
    );

    // Related Image within this 'subServices` block
    const relatedImage = subServiceBlock.getAttribute('data-associated-photo');
    const featuredImageWrapper = document.querySelector(
      `.js-servicePhoto[data-block-id="${currentBlockId}"]`
    );
    const featuredImage = featuredImageWrapper
      ? featuredImageWrapper.querySelector('img')
      : null;

    // Removes all `-opened` modifier classes and adds it to the one that was clicked.
    siblingSubServices.forEach(siblingSubService => {
      siblingSubService.classList.remove('-opened');
    });

    subServiceBlock.classList.add('-opened');

    // Swaps in new image related to the subService in the `featuredimage`
    // Removes old one after new one is added.

    if (relatedImage) {
      const newImage = featuredImage.cloneNode(false);
      newImage.setAttribute('data-src', relatedImage);
      newImage.classList.remove('lazyloaded');
      newImage.classList.add('lazyload');

      featuredImageWrapper.appendChild(newImage);

      setTimeout(() => {
        featuredImage.remove();
      }, 1000);
    }
  });
});

// Collapsing current subservice.
subServiceCloseButtons.forEach(closeButton => {
  closeButton.addEventListener('click', async () => {
    const subServiceId = closeButton.getAttribute('data-service-id');

    const subServiceToClose = document.querySelector(`
            .js-subService[data-service-id="${subServiceId}"]
        `);

    // RAF used to let rendering catch up. Won't work otherwise.
    window.requestAnimationFrame(() => {
      subServiceToClose.classList.remove('-opened');
    });
  });
});
